import React, { useEffect, useLayoutEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Homes from "./components/Homes";
import Blogs from "./components/Blogs";
import Faq from "./components/faq/Faq";
import Dos from "./components/Tools/Dos";
import Beauty from "./components/Dolist/Beauty";
import Kicker from "./components/Tools/Kicker";
import Contraction from "./components/Tools/Contraction";
import Trim from "./components/Tools/Trim";
import Trimster from "./components/Tools/Trimster";
import Trimster2 from "./components/Tools/Trimster2";
import Trimster3 from "./components/Tools/Trimster3";
import Trimster4 from "./components/Tools/Trimster4";
import Trimster5 from "./components/Tools/Trimster5";
import Videos from "./components/Tools/Videos";

import ShowKicker from "./components/Tools/ShowKicker";
import KickerChart from "./components/Tools/KickerChart";
import TrimsterChart from "./components/Tools/TrimsterChart";

import PreCalendar from "./components/Tools/PreCalendar";
import CommonHealthIssue from "./components/Tools/CommonHealthIssue";
import Fitness from "./components/Dolist/Fitness";
import Health from "./components/Dolist/Health";
import NutandWeight from "./components/Dolist/NutandWeight";
import SexCont from "./components/Dolist/SexCont";
import Sleep from "./components/Dolist/Sleep";
import Travel from "./components/Dolist/Travel";
import HomeWork from "./components/Dolist/HomeWork";
import Yoga from "./components/Dolist/Yoga";
import OtherTools from "./components/Home/OtherTools";
import RandomFacts from "./components/Tools/RandomFacts";
import YogaMom from "./components/Tools/YogaMom";
import Workout from "./components/Tools/Workout";
import Products from "./components/Tools/Products";
import Quotes from "./components/Tools/Quotes";
import ChartForShare from "./components/Tools/ChartForShare";
import DietChart from "./components/video/DietChart";
import DoVideo from "./components/video/DoVideo";
import DontVideos from "./components/video/DontVideos";
import Mom1 from "./components/video/Mom1";
import Mom2 from "./components/video/Mom2";
import Mom3 from "./components/video/Mom3";
import BabyVideo1 from "./components/video/BabyVideo1";
import BabyVideo2 from "./components/video/BabyVideo2";
import BabyVideo3 from "./components/video/BabyVideo3";
import WorkTrim1 from "./components/wrktlist/WorkTrim1";
import WorkTrim2 from "./components/wrktlist/WorkTrim2";
import WorkTrim3 from "./components/wrktlist/WorkTrim3";
import YogaMonth1 from "./components/yogalist/YogaMonth1";
import YogaMonth2 from "./components/yogalist/YogaMonth2";
import YogaMonth3 from "./components/yogalist/YogaMonth3";
import YogaMonth4 from "./components/yogalist/YogaMonth4";
import YogaMonth5 from "./components/yogalist/YogaMonth5";
import YogaMonth6 from "./components/yogalist/YogaMonth6";
import YogaMonth7 from "./components/yogalist/YogaMonth7";
import YogaMonth8 from "./components/yogalist/YogaMonth8";
import YogaMonth9 from "./components/yogalist/YogaMonth9";
import MomProducts from "./components/products/MomProducts";
import BabyProducts from "./components/products/BabyProducts";
import ImageQuote from "./components/qoutelist/ImageQuote";
import TextQuote from "./components/qoutelist/TextQuote";
import BabyNames from "./components/Tools/BabyNames";
import Blog1 from "./components/Blog1";
import AboutUs from "./components/aboutus/AboutUs";
import ContactUs from "./components/contactus/ContactUs";
import Login from "./components/Login";
import ScrollToTop from "./components/ScrollToTop";
import GetData from "./components/GetData";
import Blog2 from "./components/Blog2";
import Blog3 from "./components/Blog3";
import { ToastContainer } from "react-bootstrap";
import Home3 from "./components/Home/Home3";
import Home4 from "./components/Home/Home4";

function App() {
  const [selectedTool, setSelectedTool] = useState("");

  const handleLinkClick = (tool) => {
    setSelectedTool(tool);
  };

  const resetToolSelection = () => {
    setSelectedTool("");
  };

  return (
    <div>
      <Router>
        <Header selectedTool={selectedTool} setSelectedTool={setSelectedTool} />
        <ScrollToTop />
        <Routes>
          <Route path="/get" element={<GetData />}></Route>
          {/* Main Routes */}
          <Route
            path="/"
            element={
              <Homes
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
              />
            }
          />
          <Route
            path="/login"
            element={
              <Login
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
              />
            }
          ></Route>

          <Route path="/help-support" element={<ContactUs />} />
          <Route
            path="/faqs"
            element={
              <Faq
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
              />
            }
          ></Route>
          <Route path="/aboutus" element={<AboutUs />}></Route>
          <Route path="/contacts" element={<ContactUs />}></Route>
          <Route path="/tools" element={<Home4 />}></Route>

          <Route path="/blogs" element={<Blogs />} />

          <Route path="blogs">
            <Route element={<Blogs />} index={true} />
            <Route path="blog1" element={<Blog1 />}></Route>
            <Route path="blog2" element={<Blog2 />}></Route>
            <Route path="blog3" element={<Blog3 />}></Route>
          </Route>

          {/* For DOS AND DONTS................................ */}
          <Route path="dos-donts">
            {" "}
            //no element attribute here
            <Route
              index={true}
              element={
                <Dos
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="beauty-style"
              element={
                <Beauty
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="fitness"
              element={
                <Fitness
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="health"
              element={
                <Health
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="wellness"
              element={
                <NutandWeight
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="Conception"
              element={
                <SexCont
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="sleep"
              element={
                <Sleep
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="travel"
              element={
                <Travel
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="housework"
              element={
                <HomeWork
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="yoga"
              element={
                <Yoga
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
          </Route>

          {/* Kicker */}
          <Route path="kick-timer">
            {" "}
            //no element attribute here
            <Route
              index={true}
              element={
                <Kicker
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route path="counts">
              <Route index={true} element={<ShowKicker />} />
              <Route path="chart" element={<KickerChart />} />
              <Route path="previous-chart" element={<ChartForShare />} />
            </Route>
          </Route>

          <Route path="checklist">
            {" "}
            //no element attribute here
            <Route
              index={true}
              element={
                <Trim
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="trimester-1"
              element={
                <Trimster
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-2"
              element={
                <Trimster2
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-3"
              element={
                <Trimster3
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="before-delivery"
              element={
                <Trimster4
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="after-delivery"
              element={
                <Trimster5
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
          </Route>
          <Route path="/trimester-chart">
            <Route
              index={true}
              element={
                <TrimsterChart
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
          </Route>
          <Route
            path="/health-issues"
            element={
              <CommonHealthIssue
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
              />
            }
          ></Route>

          <Route
            path="/random-facts"
            element={
              <RandomFacts
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
              />
            }
          />
          <Route
            path="/contraction"
            element={
              <Contraction
                selectedTool={selectedTool}
                setSelectedTool={setSelectedTool}
              />
            }
          />

          {/* I need Videos List ..................................................*/}
          <Route path="videos">
            <Route
              element={
                <Videos
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
              index={true}
            />
            <Route
              path="dietchart"
              element={
                <DietChart
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="pregnancy-dos"
              element={
                <DoVideo
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="pregnancy-donts"
              element={
                <DontVideos
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-1-mom"
              element={
                <Mom1
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-2-mom"
              element={
                <Mom2
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-3-mom"
              element={
                <Mom3
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-1-baby"
              element={
                <BabyVideo1
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-2-baby"
              element={
                <BabyVideo2
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="trimester-3-baby"
              element={
                <BabyVideo3
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
          </Route>

          <Route path="exercise">
            <Route
              index={true}
              element={
                <Workout
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            />
            <Route
              path="exercise-1"
              element={
                <WorkTrim1
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="exercise-2"
              element={
                <WorkTrim2
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="exercise-3"
              element={
                <WorkTrim3
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
          </Route>

          {/* Yoga Tool.......................... */}
          <Route path="Pregnancy-yoga">
            <Route
              index={true}
              element={
                <YogaMom
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-1"
              element={
                <YogaMonth1
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-2"
              element={
                <YogaMonth2
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-3"
              element={
                <YogaMonth3
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-4"
              element={
                <YogaMonth4
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-5"
              element={
                <YogaMonth5
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-6"
              element={
                <YogaMonth6
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-7"
              element={
                <YogaMonth7
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-8"
              element={
                <YogaMonth8
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="yoga-9"
              element={
                <YogaMonth9
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
          </Route>
          {/* <ToastContainer /> */}
          <Route path="products">
            <Route
              element={
                <Products
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
              index={true}
            ></Route>
            <Route
              path={`momproducts`}
              element={
                <MomProducts
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="babyproducts"
              element={
                <BabyProducts
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
          </Route>

          {/* Quotes.............................. */}
          <Route path="quotes">
            <Route
              element={
                <Quotes
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
              index={true}
            />
            <Route
              path="image-quotes"
              element={
                <ImageQuote
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
            <Route
              path="text-quotes"
              element={
                <TextQuote
                  selectedTool={selectedTool}
                  setSelectedTool={setSelectedTool}
                />
              }
            ></Route>
          </Route>
          {/* Baby Names................................... */}
          {/* <Route path="/babynames" element={<BabyNames />}></Route> */}
        </Routes>

        <Footer selectedTool={selectedTool} setSelectedTool={setSelectedTool} />
      </Router>
    </div>
  );
}

export default App;
